// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"e21f2742","576":"890a06d4","716":"a2493cf6"}[chunkId] + ".chunk.css";
};